<template>
  <div>
    <div id="shareNav" class='to-form-share' :style="navPosition"
         @mousedown="navDown" @touchstart="navDown"
         @mousemove="navMove" @touchmove="navMove"
         @mouseup="navEnd" @touchend="navEnd">
      <img src="../assets/images/activity/bg-Ashare-icon.png" alt srcset  @click="onShow"   />
    </div>

    <div class="xuanfu info-nr-phone" id="moveDiv" :style="position"
         @mousedown="down" @touchstart="down"
         @mousemove="move" @touchmove="move"
         v-if="navShow"
         @mouseup="end" @touchend="end">
    </div>
  </div>
</template>


<style scoped>
.to-form-share {
  width: 1.1rem;
  height: 1.1rem;
  position: fixed;
  right: 0.2rem;
  top: 9rem;
  z-index: 3;
}
.to-form-share img {
  width: 100%;
}
</style>

<script>
import Vue from 'vue'
import {
  Toast, Button, Dialog, Overlay
} from 'vant';

Vue.use(Toast).use(Button).use(Dialog).use(Overlay);
export default {
  name: "BusinessNavShare",
  props: { 
  },
  watch: { 

  },
  mounted() {
    let that = this;
    let nav_float = localStorage.getItem('_share_float');
    if (nav_float) {
      that.navPosition = JSON.parse(nav_float)
    }
  },

  data: function () {
    return {
      navShow: false,
      flags: false,
      effectShow: false,
      num: 0,
      position: {
        top: "8.85rem",
        left: "5.65rem"
      },
      navPosition: {
        top: "10.5rem",
        left: "6.15rem"
      },
      positionTemp: {x: 0, y: 0},   // 记录手指点击的位置
      nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',

      navFlags: false,
      navPositionTemp: {x: 0, y: 0},   // 记录手指点击的位置
      navNx: '', navNy: '', navDx: '', navDy: '', navxPum: '', navyPum: '',
    }
  },
  methods: {

    onShow() {
      this.$emit('show')
    },
    navDown() {
      /*if (this.fixed) {
          return
      }*/

      this.navFlags = true;
      var touch;
      // 该if判断是用touch还是mouse来移动
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.navPositionTemp.x = touch.clientX;   // 手指点击后的位置
      this.navPositionTemp.y = touch.clientY;

      this.navDx = shareNav.offsetLeft;    // 移动的div元素的位置
      this.navDy = shareNav.offsetTop;

      // console.log("moveDiv.offsetLeft", moveDiv.offsetLeft)
      // console.log("touch.clientX", touch.clientX)
    },
    navMove() {
      if (this.navFlags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.navNx = touch.clientX - this.navPositionTemp.x;   // 手指移动的变化量
        this.navNy = touch.clientY - this.navPositionTemp.y;

        this.navxPum = this.navDx + this.navNx;   // 移动后，div元素的位置
        this.navyPum = this.navDy + this.navNy;


        let windowWidth = document.documentElement.clientWidth
        let windowHeight = document.documentElement.clientHeight
        // console.log("window.clientWidth", windowWidth)
        // console.log(this.navxPum, this.navyPum)
        /*localStorage.setItem('_nav_top', this.xPum)
        localStorage.setItem('_nav_left', this.yPum)*/
        if (this.navxPum > windowWidth) {
          this.navxPum = windowWidth - 70
        }
        if (this.navyPum >= windowHeight) {
          this.navyPum = windowHeight - 70;
        }
        if (this.navyPum < 0) {
          this.navyPum = 0
        }

        if (this.navxPum < 0) {
          this.navxPum = 0
        }


        localStorage.setItem('_share_float', JSON.stringify({
          'left': this.navxPum + "px",
          'top': this.navyPum + "px"
        }))
        // console.log(" moveDiv.clientWidth",  moveDiv.clientWidth)

        if (this.navxPum > 0 && (this.navxPum + shareNav.clientWidth < windowWidth)) {
          // movediv的左右边，未出界
          shareNav.style.left = this.navxPum + "px";
        } else if (this.navxPum <= 0) {
          // 左边出界，则左边缘贴边
          shareNav.style.left = 0 + "px";
        } else if (this.navxPum + shareNav.clientWidth >= windowWidth) {
          // 右边缘出界
          shareNav.style.left = (windowWidth - shareNav.clientWidth) + "px";
          // console.log("dx", windowWidth - moveDiv.clientWidth)
        }
        // 上下未出界
        if (this.navyPum > 0 && (this.navyPum + shareNav.clientHeight < windowHeight)) {
          shareNav.style.top = this.navyPum + "px";
        } else if (this.navyPum <= 0) {
          // 上边缘出界
          shareNav.style.top = 0 + "px"
        } else if (this.navyPum + shareNav.clientHeight >= windowHeight) {
          // 下边缘
          // console.log("windowHeight:", windowHeight)
          // console.log("shareNav.clientHeight:", shareNav.clientHeight)
          // console.log(this.navyPum + shareNav.clientHeight)
          shareNav.style.top = windowHeight - shareNav.clientHeight + "px"
        }

        // 阻止页面的滑动默认事件，为了只让悬浮球滑动，其他部分不滑动；如果碰到滑动问题，1.2 请注意是否获取到 touchmove, 系统默认passive: true，无法使用preventDefault
        // document.addEventListener("touchmove", function(){
        //    event.preventDefault();
        // }, { passive: false });
        // document.addEventListener("mousemove", function(){
        //     event.preventDefault();
        // }, { passive: false });
        document.addEventListener("touchmove", this.navpreventDefault, {passive: false})
        document.addEventListener("mousemove", this.navpreventDefault, {passive: false})
      }
    },
    //鼠标释放时候的函数，鼠标释放，移除之前添加的侦听事件，将passive设置为true，不然背景会滑动不了
    navEnd() {
      this.flags = false
      // 注意事项，在添加和删除监听事件时，其function必须是同名的函数，不能为匿名函数。
      document.removeEventListener('touchmove', this.navpreventDefault, false)
      document.removeEventListener('mousemove', this.navpreventDefault, false)
      // 下面两句是保证在移除监听事件后，除了悬浮球的部分还能够滑动，如果不添加，则无法滑动
      document.addEventListener("touchmove", function (e) {
        window.event.returnValue = true
      })
      document.addEventListener("mousemove", function (e) {
        window.event.returnValue = true
      })
    },

    navpreventDefault(e) {
      e.preventDefault()
    },


    // 实现移动端拖拽
    down() {
      if (this.fixed) {
        return
      }

      this.flags = true;
      var touch;
      // 该if判断是用touch还是mouse来移动
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.positionTemp.x = touch.clientX;   // 手指点击后的位置
      this.positionTemp.y = touch.clientY;

      this.dx = moveDiv.offsetLeft;    // 移动的div元素的位置
      this.dy = moveDiv.offsetTop;

      // console.log("moveDiv.offsetLeft", moveDiv.offsetLeft)
      // console.log("touch.clientX", touch.clientX)
    },
    move() {
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.positionTemp.x;   // 手指移动的变化量
        this.ny = touch.clientY - this.positionTemp.y;

        this.xPum = this.dx + this.nx;   // 移动后，div元素的位置
        this.yPum = this.dy + this.ny;


        let windowWidth = document.documentElement.clientWidth
        let windowHeight = document.documentElement.clientHeight
        // console.log("window.clientWidth", windowWidth)
        console.log(windowWidth, windowHeight)
        /*localStorage.setItem('_nav_top', this.xPum)
        localStorage.setItem('_nav_left', this.yPum)*/
        if (this.xPum > windowWidth) {
          this.xPum = windowWidth - 70
        }
        if (this.yPum > windowHeight) {
          this.yPum = windowHeight - 70;
        }
        if (this.yPum < 0) {
          this.yPum = 0
        }

        if (this.xPum < 0) {
          this.xPum = 0
        }


        /*localStorage.setItem('_nav', JSON.stringify({
            'left': this.xPum + "px",
            'top': this.yPum + "px"
        }))*/
        // console.log(" moveDiv.clientWidth",  moveDiv.clientWidth)

        if (this.xPum > 0 && (this.xPum + moveDiv.clientWidth < windowWidth)) {
          // movediv的左右边，未出界
          moveDiv.style.left = this.xPum + "px";
        } else if (this.xPum <= 0) {
          // 左边出界，则左边缘贴边
          moveDiv.style.left = 0 + "px";
        } else if (this.xPum + moveDiv.clientWidth >= windowWidth) {
          // 右边缘出界
          moveDiv.style.left = (windowWidth - moveDiv.clientWidth) + "px";
          // console.log("dx", windowWidth - moveDiv.clientWidth)
        }
        // 上下未出界
        if (this.yPum > 0 && (this.yPum + moveDiv.clientHeight < windowHeight)) {
          moveDiv.style.top = this.yPum + "px";
        } else if (this.yPum <= 0) {
          // 上边缘出界
          moveDiv.style.top = 0 + "px"
        } else if (this.yPum + moveDiv.clientHeight >= windowHeight) {
          // 下边缘
          // console.log("windowHeight:", windowHeight)
          // console.log("moveDiv.clientHeight:", moveDiv.clientHeight)
          // console.log(this.yPum + moveDiv.clientHeight)
          moveDiv.style.top = windowHeight - moveDiv.clientHeight + "px"
        }

        // 阻止页面的滑动默认事件，为了只让悬浮球滑动，其他部分不滑动；如果碰到滑动问题，1.2 请注意是否获取到 touchmove, 系统默认passive: true，无法使用preventDefault
        // document.addEventListener("touchmove", function(){
        //    event.preventDefault();
        // }, { passive: false });
        // document.addEventListener("mousemove", function(){
        //     event.preventDefault();
        // }, { passive: false });
        document.addEventListener("touchmove", this.preventDefault, {passive: false})
        document.addEventListener("mousemove", this.preventDefault, {passive: false})
      }
    },
    //鼠标释放时候的函数，鼠标释放，移除之前添加的侦听事件，将passive设置为true，不然背景会滑动不了
    end() {
      this.flags = false
      // 注意事项，在添加和删除监听事件时，其function必须是同名的函数，不能为匿名函数。
      document.removeEventListener('touchmove', this.preventDefault, false)
      document.removeEventListener('mousemove', this.preventDefault, false)
      // 下面两句是保证在移除监听事件后，除了悬浮球的部分还能够滑动，如果不添加，则无法滑动
      document.addEventListener("touchmove", function (e) {
        window.event.returnValue = true
      })
      document.addEventListener("mousemove", function (e) {
        window.event.returnValue = true
      })
    },
    preventDefault(e) {
      e.preventDefault()
    },
  }
}
</script>




// WEBPACK FOOTER //
// NavFloatShare.vue?058b5cc6